export default function AIFeaturesSection() {
  return (
    <section className="bg-gray-50 py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-medium mb-6">
            🤖 Impulsado por Google Gemini
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Inteligencia Artificial en cada paso de tu producción
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La IA de QPulseMES siempre asiste — nunca decide por ti. Cada sugerencia se revisa y se aprueba antes de tocar tus datos reales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mb-6">
              <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Optimización de Producción con IA</h3>
            <p className="text-gray-600 mb-4">
              Describe tu objetivo en lenguaje natural y Gemini propone una reprogramación completa de órdenes a máquinas — minimiza tiempos de cambio, respeta fechas de entrega y balancea la carga entre equipos. Tú siempre revisas y apruebas antes de que cualquier cambio se aplique.
            </p>
            <span className="inline-block bg-purple-50 text-purple-700 text-xs font-medium px-3 py-1 rounded-full">
              Tablero de Planeación
            </span>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6">
              <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Asistente Conversacional QPulse</h3>
            <p className="text-gray-600 mb-4">
              Un asistente de IA integrado en toda la plataforma, disponible en cualquier módulo. Responde preguntas sobre indicadores, procesos y flujos de trabajo en español, en el momento que las necesitas.
            </p>
            <span className="inline-block bg-blue-50 text-blue-700 text-xs font-medium px-3 py-1 rounded-full">
              Disponible en toda la app
            </span>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mb-6">
              <svg className="w-8 h-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-14 0m7 0v4m0 0H9m3 0h3m-3-4a3 3 0 003-3V5a3 3 0 00-6 0v6a3 3 0 003 3z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Transcripción de Voz a Texto</h3>
            <p className="text-gray-600 mb-4">
              Graba un mensaje de voz dentro del asistente y la IA lo transcribe automáticamente al español — sin necesidad de escribir mientras trabajas en planta.
            </p>
            <span className="inline-block bg-emerald-50 text-emerald-700 text-xs font-medium px-3 py-1 rounded-full">
              Chat con IA
            </span>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
            <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6">
              <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Detección de Peso por Foto (Visión IA)</h3>
            <p className="text-gray-600 mb-4">
              Durante la ejecución en planta, fotografía la báscula y Gemini Vision detecta automáticamente el peso, la unidad y la confianza de la lectura — reduciendo errores de captura manual en cada pesaje.
            </p>
            <span className="inline-block bg-orange-50 text-orange-700 text-xs font-medium px-3 py-1 rounded-full">
              Ejecución de Planta
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
